import React, { useState } from "react";
// import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import phoneCodes from './jsonData/phoneCodes.json';

// import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/style.css';

const ProfileDetail = () => {
  const route = all_routes;
  const navigate = useNavigate();
  const location = useLocation();
  // State for form inputs and validation messages
  const [storeName, setStoreName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneCode, setPhoneCode] = useState(phoneCodes[0].code);
  const [errors, setErrors] = useState({});

  // Function to handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    // Validation
    const errors = {};
    if (!storeName.trim()) {
      errors.storeName = "Company Name is required";
    }
    if (!email.trim()) {
      errors.email = "Email Address is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      errors.email = "Invalid email address";
    }
    if (!phoneNumber.trim()) {
      errors.phoneNumber = "Phone Number is required";
    }
    setErrors(errors);

    // If no errors, proceed with form submission
    if (Object.keys(errors).length === 0) {
      const formData = location.state;
    
      formData.tenant= {
        companyName: storeName,
        email: email,
        companyPhone: phoneCode +" "+ phoneNumber,
        domain: email.split('@')[1].toString(),
        industryId: "1",
        industry: "Crow Craft"
      }
      console.log("formData:", formData);
      navigate(route.Address, { state: formData });
      // Perform any other actions here (e.g., navigation)
    }
  };

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper">
        <div className="login-img">
            <ImageWithBasePath src="assets/img/authentication/login02.png" alt="img" />
          </div>
          <div className="login-content">
            <form onSubmit={handleSubmit} style={{ width: '80%' }}>
              <div className="login-userset">
                <div className="login-logo logo-normal">
                  <ImageWithBasePath src="assets/img/logo.png" alt="img" />
                </div>
                <Link to={route.dashboard} className="login-logo logo-white">
                  <ImageWithBasePath src="assets/img/logo-white.png" alt="img" />
                </Link>
                <div className="login-userheading">
                  <h3>Profile</h3>
                </div>
                <div className="form-login">
                  <label>Company Name</label>
                  <div className="form-addons">
                    <input
                      type="text"
                      className="form-control"
                      value={storeName}
                      onChange={(e) => {
                        setStoreName(e.target.value)
                        setErrors(prevErrors => ({ ...prevErrors, storeName: false }));
                      }}
                    />
                    <ImageWithBasePath src="assets/img/icons/user-icon.svg" alt="img" />
                  </div>
                  {errors.storeName && <p className="text-danger">{errors.storeName}</p>}
                </div>
                <div className="form-login">
                  <label>Email Address</label>
                  <div className="form-addons">
                    <input
                      type="text"
                      className="form-control"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setErrors(prevErrors => ({ ...prevErrors, email: false }));
                      }}
                    />
                    <ImageWithBasePath src="assets/img/icons/mail.svg" alt="img" />
                  </div>
                  {errors.email && <p className="text-danger">{errors.email}</p>}
                </div>
                {/* <div className="form-login">
                  <label>Phone number</label>
                  <div className="form-addons">
                  <select
                      className="form-control"
                      value={phoneCode}
                      onChange={(e) => setPhoneCode(e.target.value)}
                    >
                      {phoneCodes.map((code, index) => (
                        <option key={index} value={code.code}>
                          {code.country} ({code.code})
                        </option>
                      ))}
                    </select>
                    <input
                      type="text"
                      className="form-control"
                      value={phoneNumber}
                      maxLength={20}
                      onChange= {(e) =>  {
                        const re = /^\+?[0-9]*$/;
                        if (re.test(e.target.value) || e.target.value === '') {
                          setPhoneNumber(e.target.value);
                          setErrors(prevErrors => ({ ...prevErrors, phoneNumber: false }));
                        }
                      }}
                    />
                    <ImageWithBasePath src="assets/img/icons/user-icon.svg" alt="img" />
                  </div>
                  {errors.phoneNumber && <p className="text-danger">{errors.phoneNumber}</p>}
                </div> */}
                <div className="form-login">
                  <label>Phone number</label>
                  <div className="form-addons" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <select
                      className="form-control"
                      value={phoneCode}
                      onChange={(e) => setPhoneCode(e.target.value)}
                      style={{ flex: 1 }}
                    >
                      {phoneCodes.map((code, index) => (
                        <option key={index} value={code.code}>
                          {code.country} ({code.code})
                        </option>
                      ))}
                    </select>
                    <input
                      type="text"
                      className="form-control"
                      value={phoneNumber}
                      maxLength={10}
                      onChange={(e) => {
                        const re = /^\+?[0-9]*$/;
                        if (re.test(e.target.value) || e.target.value === '') {
                          setPhoneNumber(e.target.value);
                          setErrors((prevErrors) => ({ ...prevErrors, phoneNumber: false }));
                        }
                      }}
                      style={{ flex: 2 }}
                    />
                        <ImageWithBasePath src="assets/img/icons/user-icon.svg" alt="img" />
               
                  </div>
                  {errors.phoneNumber && <p className="text-danger">{errors.phoneNumber}</p>}
                </div>


                <div className="form-login">
                  <button type="submit" className="btn btn-login">Next</button>
                </div>
                <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                  <p>Copyright © 2024 WizzTech. All rights reserved</p>
                </div>
              </div>
            </form>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default ProfileDetail;